export const take = (input, ...keys) => {
    return keys.reduce((acc, k) => {
        const v = input[k];
        if (typeof v === 'undefined') {
            return acc;
        }
        return Object.assign(Object.assign({}, acc), { [k]: v });
    }, {});
};
//# sourceMappingURL=takePayload.js.map